import { Injectable } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { MrsiService } from 'src/app/mrsi/service/mrsi.service';
import {ReportService} from 'src/app/repository/service/report.service';
import { LoginService } from 'src/app/services/login.service';
import { VisibilityService } from '../visibility.service';
import { HomeService } from '../home.service';
import { QaReportService } from 'src/app/qa-report-dashboard/services/qa-report.service';
import { MatDialog } from '@angular/material/dialog';
import { IcvDemoVideoComponent } from 'src/app/consumer-immersions/request-list/icv-demo-video/icv-demo-video.component';
import { SupersetDashboardService } from 'src/app/superset-dashboard/service/superset-dashboard.service';

class SideDrawer{
  mainMenu:MenuDetails[] = [];
  subMenu:SubMenu[] = [];
  globalSearch:boolean = false;
  mainMenuOpen:boolean = true;
  subMenuOpen:boolean = false;
  userName:string = '';
  userOrg:string = '';
  subMenuTitle:string = '';
}

class MenuDetails{
  name:string = '';
  uuid:string = '';
  route:string = '';
  url:string = '';
  src:string = '/assets/images/';
  newSrc:string = '/assets/Landing_Page_Icon/';
  routerLink:string = '';
  routerLinkActive:string = '';
  visibility:boolean = false;
  file:any = {};
  filters:any = [];
  isTreeLevelOne:boolean = false;
  isDropdownItems:boolean = false;
  routerLinkActiveOptions:any = {exact: false};
  highLighterCont:any[] = [];
  style:any = {};
  dash_uuid:string = '';
}

class SubMenu extends MenuDetails {
  dropDown:MenuDetails[] = [];
  isDropdown:boolean = false;
  isTree:boolean = false;
  isSubMenuTitle:boolean = false;
  isVioletTheme:boolean = false;
  isHighlighter:boolean = false;
  newSrc:string = '/assets/Landing_Page_Icon/';
  dropdown_route:string = '';
}


@Injectable({
    providedIn: 'root'
  })
export class SidePanelService{

    public sideDrawer = new SideDrawer();
    public access:any;
    public initFor:string = '';
    public studyId:string = '';
    public visibilityData:any = null;
    public isDiarySurvey:boolean = false;
    public isSurveyShow:boolean = false;
    public SurveyId:any;
    public isFunnelReport:boolean = false;
    public isTermReport:boolean = false;
    public isUtmReport:boolean = false;
    public isDemoUserWithSuperAccess:boolean = false;
    public isGuestAccount:boolean = false;
    public prevChannel:any = "";
    public isSurveyPreviewFromResearch:boolean = false;
    public mrsiEventListOverallCountDetails = {};
    public realSurveyId:any;
    public isCIHighlighterShow:boolean = true;
    public isSidePanelCIVideoHighlighterShow:boolean = true;
    public IsICVCreditFloW:boolean = false;
    public superSetSubMenuDashCont:any[] = [];

    // Visibility cache to avoid unnecessary API calls
    private visibilityCache: Map<string, { data: any, timestamp: number }> = new Map();
    private readonly CACHE_DURATION_MS = 5 * 60 * 1000; // 5 minutes cache duration
    private visibilityLoadingMap: Map<string, boolean> = new Map();
    private tncCheckedForRoute:string = '';
    private lastRepoInitStudyId:string = '';

    public genericAccountNotification:string = "Limited access on Guest Account.";



    constructor(
      private LogoutService: LoginService,
      private reportService:ReportService,
      private notifier: NotifierService,
      private mrsiService:MrsiService,
      private visibilityService:VisibilityService,
      private homeService:HomeService,
      private qaService:QaReportService,
      private dialog:MatDialog,
      private superSetService:SupersetDashboardService,
      private router: Router){
      
      this.reportService.initSideDrawerEvent
        .subscribe((panel: string)=> {
          // console.log('this.initSideDrawer',panel);
          this.initSideDrawer(panel);
          // if(panel == 'repo'){
          //   this.updateSideDrawer('home')
          // }
        })
        this.qaService.initSideDrawerEvent
        .subscribe((panel: string)=> {
          this.initSideDrawer(panel);
        })
        this.reportService.redirectUnAuthorizedEvent
        .subscribe((value: string)=> {
          this.afterLoginNavigate();
        })  
        if (this.LogoutService.setSideDrowerEvent) {
          this.LogoutService.setSideDrowerEvent.subscribe(() => {
            this.setSideDrower('');
          });
        }

     
    }
    
    switchGlobalSearch(status){
      this.sideDrawer.globalSearch = status;
    }

    resetSideDrawer() {
      this.homeService.isOpen = false;
      this.sideDrawer = new SideDrawer();
    }
    
    checkGuestAccountAccess(){
      this.access = JSON.parse(localStorage.getItem('access'));
      if(this.access && this.access.org_id && (this.access.org_id == '636bb3e5-4549-12e9-8d03-c8e86e35ddf3')){
        this.isGuestAccount = true;
      }else{
        this.isGuestAccount = false;
      }
    }

    initSideDrawer(value:string, options?:any){
      // console.log("Initializing Side Drawer for ===> ",value);
      const currentRoute = this.router.url;
      
      // Only check TNC status once per route navigation
      if (this.tncCheckedForRoute !== currentRoute) {
        this.tncCheckedForRoute = currentRoute;
        this.checkForTncStatus();
      }
      
      // console.log("Initializing Side Drawer for ===> ",value);
      // this.checkForTncStatus();
      this.access = JSON.parse(localStorage.getItem('access'));
      
      // Guard: if no access data, cannot build menu
      if (!this.access || !this.access['access_rules']) {
        console.warn('No access data available for side drawer');
        return;
      }
      
      if(this.access && this.access.id &&  this.access.id == '63f1db1a-5222-11ee-ad29-42010aa00020'){
        this.isDemoUserWithSuperAccess = true;
      }
      // this.getSubMenuForSuperSet();
      this.checkGuestAccountAccess();
      // this.access.org_id == 'cb9f120a-284a-11e9-83cd-42010a8e0002' || 
      // if(this.access && this.access.org_id && (this.access.org_id == '636bb3e5-4549-12e9-8d03-c8e86e35ddf3')){
      //   this.isGuestAccount = true;
      // }
      this.initFor = value;
      this.sideDrawer.userName = this.access['name'];
      this.sideDrawer.userOrg = this.access['org_name'];
      this.sideDrawer.subMenu = [];
      this.sideDrawer.mainMenu = [];
      Object.keys(this.access['access_rules']).forEach((key)=>{
        if(key == 'global_search'){
          this.switchGlobalSearch(this.router.url.includes('repo') || this.router.url.includes('topline')  ? false: this.access['access_rules']['global_search']['view']);
          // this.switchGlobalSearch(this.router.url.includes('repository-report') ? false: this.access['access_rules']['global_search']['view']);
        }
        if(key == 'side_drawer'){
          this.SetMenusDetailsPrefered();
        }
        if(key == 'study' && (this.initFor == 'home' || this.initFor == 'qual')){
          let subSideDrowerPriority = ['performance_panel','panel_list','recruiter','visibility_control','funnel_report','biReport','interview','qual_report','']
          let sortedSubSideDrower =[];
          subSideDrowerPriority.forEach((Skey,index)=>{
            if (this.access['access_rules'][key] && this.access['access_rules'][key][Skey] && this.access['access_rules'][key][Skey]['view']) {
              sortedSubSideDrower.push({"key":Skey,"value":this.access['access_rules'][key][Skey]})
            }
          });
          // Object.keys(this.access['access_rules'][key]).forEach((Skey)=>{
          //   console.log("Skey ===> ",Skey)
          //   this.SetHomeMenusDetails(Skey, this.access['access_rules'][key][Skey]);
          // });
          sortedSubSideDrower.forEach((item)=>{
            this.SetHomeMenusDetails(item.key, item.value);
          });

          // if(localStorage.getItem('studyId')){
          //   let studyId = localStorage.getItem('studyId');
          //   if(studyId === 'b2ce6f3f-2848-434e-8d87-21804da0b1d6' || studyId === 'a566179a-e9bd-4810-bbc2-29fc89f9f856' || studyId === '068e0008-8bf3-4cd4-8cc4-59b78432dc63'){
          //     this.SetHomeMenusDetails('survey-Dairy',true);
          //   }
          // }
          if(sessionStorage.getItem('studyId')){
            let studyId = sessionStorage.getItem('studyId');
            if(studyId === 'b2ce6f3f-2848-434e-8d87-21804da0b1d6' || studyId === 'a566179a-e9bd-4810-bbc2-29fc89f9f856' || studyId === '068e0008-8bf3-4cd4-8cc4-59b78432dc63'){
              this.SetHomeMenusDetails('survey-Dairy',true);
            }
          }

          
          this.SetHomeMenusDetails('survey',true);
          this.SetHomeMenusDetails('superset_study',true);

          // this.SetHomeMenusDetails('surveyPreview',true);

        }
        if(key == 'side_drawer' && this.initFor == 'repo'){
          // console.log('in repo out');
          // this.SetRepoMenusDetails(true)

          this.SetRepoAndDashboardMenusDetails();

        }
        if(key == 'eagle' && this.initFor == 'eaglelive'){
          // console.log(this.access['access_rules'][key])
          Object.keys(this.access['access_rules'][key]).forEach((Skey)=>{
            this.SetEagleliveMenusDetails(Skey, this.access['access_rules'][key][Skey])
            
          });
        }
        if(key == 'consumer_immersions' && this.initFor == 'ci'){
          Object.keys(this.access['access_rules'][key]).forEach((Skey)=>{
            this.SetCIMenusDetails(Skey, this.access['access_rules'][key][Skey])
          });
          this.SetCIMenusDetails('icv_highlighter', this.isCIHighlighterShow)


        }
        if(key == 'user_management' && this.initFor == 'user'){
          Object.keys(this.access['access_rules'][key]).forEach((Skey)=>{
            this.SetUserMenusDetails(Skey, this.access['access_rules'][key][Skey])
          });
          console.log("this.access['access_rules'][key] ===> ",this.access['access_rules'][key])
          // this.SetUserMenusDetails('client-list', {view:true});
          // this.SetUserMenusDetails('unmapped_users', {view:true});
        }
        if(key == 'mrsi' && this.initFor == 'mrsi'){
            this.SetMRSIMenusDetails(true)
        }
        if(key == 'qc_dashboard' && this.initFor == 'qa-report'){
          Object.keys(this.access['access_rules'][key]).forEach((Skey)=>{
            this.SetQAReportMenu(Skey, this.access['access_rules'][key][Skey])
          });
        }
        if(key == 'side_drawer' && this.initFor == 'PT'){
          this.SetPTTrackerMenu("pt_tracker", {view:true})
          this.SetPTTrackerMenu("event_tracker", {view:true})
          // if (this.homeService.ptDetails.events) {
          // }
        }

        // if(key == 'organizations' && this.initFor == 'user'){
        //   this.SetUserMenusDetails('organizations', this.access['access_rules'][key]['view'])
          
        // }
      });

    }

   
    updateSideDrawer(value:string, options?:any){
      let initFor = value;
      if(initFor == 'repo'){
        this.SetRepoMenusDetails(true);
        // console.log('this.sideDrawer after updateSideDrawer ===> ',this.sideDrawer);
      }
    }

    SetRepoAndDashboardMenusDetails(){
      this.SetRepoMenusDetails(true);
      // console.log('this.reportService.projectDetails ===> ',this.reportService.projectDetails);
      
      // Guard: Check if required data exists before accessing
      if (!this.reportService.projectDetails || 
          !this.reportService.projectDetails['studies'] || 
          this.reportService.projectDetails['studies'].length === 0) {
        console.warn('ProjectDetails or studies not available for dashboard menu setup');
        return;
      }
      
      if(this.reportService.projectDetails && this.reportService.projectDetails['is_dashboard'] && this.access['access_rules']['side_drawer']['dashboard']){
        let key = 'study';  
        let subSideDrowerPriority = ['performance_panel','panel_list','recruiter','visibility_control','funnel_report','biReport','interview','qual_report']
        let sortedSubSideDrower =[];
        this.studyId = this.reportService.studyId;
        let study = this.reportService.projectDetails['studies'].find(study => study.study_uuid === this.studyId);
        
        // Guard: Check if study exists before accessing properties
        if (!study) {
          console.warn('Study not found for studyId:', this.studyId);
          return;
        }
        
        const studyTYPE = study && study.type && study.type == "qual" ? "qual" : 'home';
        this.initFor = studyTYPE;
        localStorage.setItem('studyTYPE', studyTYPE);
        
        subSideDrowerPriority.forEach((Skey,index)=>{
          if (this.access['access_rules'][key] && this.access['access_rules'][key][Skey] && this.access['access_rules'][key][Skey]['view']) {
            sortedSubSideDrower.push({"key":Skey,"value":this.access['access_rules'][key][Skey]})
          }
        });
        sortedSubSideDrower.forEach((item)=>{
          this.SetHomeMenusDetailsWithStudyId(item.key, item.value);
        });
        
        // Only call getDashboardVisibility if studyId changed to prevent duplicate API calls
        if (this.lastRepoInitStudyId !== this.studyId) {
          this.lastRepoInitStudyId = this.studyId;
          this.getDashboardVisibility(this.studyId);
        }
        
      }
    }

    checkForTncStatus(){
      this.LogoutService.getTermAndCond().subscribe((data) =>{
        if(data.status){
          this.LogoutService.termandCondType = data.type || '';
          this.router.navigate(['/tnc']);
        }
      })
    }


    SetMenusDetailsPrefered(){
      this.sideDrawer.mainMenu = [];
      if(this.access['access_rules']['side_drawer']['repository']){
        this.SetMenusDetails('repository', this.access['access_rules']['side_drawer']['repository'])
      }
      if(this.access['access_rules']['side_drawer']['dashboard']){
        this.SetMenusDetails('dashboard', this.access['access_rules']['side_drawer']['dashboard'])
      }
      if(this.access['access_rules']['side_drawer']['projects']){
        this.SetMenusDetails('projects', this.access['access_rules']['side_drawer']['projects'])
      }
      if(this.access['access_rules']['side_drawer']['manage_recuiters']){
        this.SetMenusDetails('manage_recuiters', this.access['access_rules']['side_drawer']['manage_recuiters'])
      }
     
      if(this.access['access_rules']['side_drawer']['consumer_immersions']){
        this.SetMenusDetails('consumer_immersions', this.access['access_rules']['side_drawer']['consumer_immersions'])
      }

      if(this.access['access_rules']['side_drawer']['quote']){
        this.SetMenusDetails('trinity', this.access['access_rules']['side_drawer']['quote'])
      }

      if(this.access['access_rules']['side_drawer']['eaglelive']){
        this.SetMenusDetails('eaglelive', this.access['access_rules']['side_drawer']['eaglelive'])
      }


      if(this.access['access_rules']['side_drawer']['user_management']){
        this.SetMenusDetails('user_management', this.access['access_rules']['side_drawer']['user_management'])
      }
      if(this.access['access_rules']['side_drawer']['survey_builder']){
        this.SetMenusDetails('survey_builder', this.access['access_rules']['side_drawer']['survey_builder'])
      }
      if(this.access['access_rules']['side_drawer']['ama']){
        this.SetMenusDetails('ama', this.access['access_rules']['side_drawer']['ama'])
      }
      if(this.access['access_rules']['side_drawer']['mrsi']){
        this.SetMenusDetails('mrsi', this.access['access_rules']['side_drawer']['mrsi'])
      }
      if(this.access['access_rules']['side_drawer']['qc_dashboard']){
        this.SetMenusDetails('qc_dashboard', this.access['access_rules']['side_drawer']['qc_dashboard'])
      }
      // if(this.access['access_rules']['side_drawer']['quote']){
      //   this.SetMenusDetails('trinity', this.access['access_rules']['side_drawer']['quote'])
      // }
      if(this.access['access_rules']['side_drawer']['contract']){
        this.SetMenusDetails('contract', this.access['access_rules']['side_drawer']['contract'])
      }

      if(this.access['access_rules']['side_drawer']['express']){
        this.SetMenusDetails('express', this.access['access_rules']['side_drawer']['express'])
      }

      if(this.access['access_rules']['side_drawer']['client_master']){
        this.SetMenusDetails('client_master', this.access['access_rules']['side_drawer']['client_master'])
      }


      if(this.access['access_rules']['side_drawer']['superset_dashboard']){
        this.SetMenusDetails('superset_dashboard', this.access['access_rules']['side_drawer']['superset_dashboard']);
      }

      this.SetMenusDetails('More',true);


      


      // this.SetMenusDetails('express', true)
      // this.SetMenusDetails('contract', true)
     
      // this.SetMenusDetails('trinity', true)

    }


    navigateToHomeDashboard(){
      this.router.navigate(['/home-dashboard']);
    }


   

    SetMenusDetails(key, value){
      let menu = new MenuDetails();
      menu.visibility = value;
      menu.routerLinkActive = 'active-home';
      switch(key){

        

        case 'repository':
            // menu.routerLink = '/home/repository-report';
            // menu.route = '/home/repository-report';
            menu.routerLink = '/repo';
            menu.route = '/repo';
            menu.name = 'Repository';
            menu.src = menu.src + 'repositiry_icon.png';
            menu.newSrc = menu.newSrc + 'Repository.png';
            break;
        case 'dashboard':
            menu.name = 'Dashboard';
            menu.routerLink = '/home/dashboard';
            menu.route = '/home/dashboard';
            menu.src = menu.src + 'Dashboard.png';
            menu.newSrc = menu.newSrc + 'Home(Dashboard).png';
            break;
        case 'projects':
          menu.name = 'Projects';
          menu.routerLink = '/home/projects';
          menu.route = '/home/projects';
          menu.src = menu.src + 'Projects.png';
          menu.newSrc = menu.newSrc + 'Projects.png';
          break;
        // case 'manage_recuiters':
        //   menu.name = 'Manage Recuiters';
        //   menu.routerLink = '/home/recruiters';
        //   menu.route = '/home/recruiters';
        //   menu.src = menu.src + 'Manage_recruiter.png';
        //   menu.newSrc = menu.newSrc + 'User-Management.png';
        //   break;
        case 'eaglelive':
          menu.name = 'Eaglelive';
          menu.routerLinkActiveOptions= {exact: false};
          menu.routerLink = '/eagle-live';
          menu.route = '/eagle-live/dashboard';
          menu.src = menu.src + 'ellogowhite.png';
          menu.newSrc = menu.newSrc + 'eaglelive_icon.png';
          menu.visibility = value && (this.access['super'] && this.access['super'] == true);
          break;
        // case 'survey_builder':
        //   menu.name = 'Survey Builder';
        //   menu.routerLink = '/surveys';
        //   menu.route = '/surveys/listing';
        //   menu.src = menu.src + 'survey_builder.png';
        //   menu.newSrc = menu.newSrc + 'survey_builder_icon.png';
        //   menu.visibility = this.isDemoUserWithSuperAccess ? false : value && (this.access['super'] && this.access['super'] == true);
        //   break;
        case 'zoom_recording':
          menu.name = 'Zoom Recording';
          menu.routerLink = '/eagle-live/zoom-recording';
          menu.route = '/eagle-live/zoom-recording';
          menu.src = menu.src + 'ellogowhite.png';
          menu.newSrc = menu.newSrc + 'eaglelive_icon.png';
          menu.visibility = false;
          break;
        case 'consumer_immersions':
          menu.name = 'Ipsos Consumer Voice (ICV)';
          // menu.name = 'Customer Immersions';
          menu.routerLinkActiveOptions= {exact: false};
          menu.routerLink = '/consumer-immersions';
          menu.route = '/consumer-immersions/request-list';
          menu.src = menu.src + 'ci_icon.png';
          menu.newSrc = menu.newSrc + 'icv.png';
          break;
        case 'user_management':
            menu.name = 'User Management';
            menu.routerLinkActiveOptions= {exact: false};
            menu.routerLink = '/user-manager';
            menu.route = '/user-manager/users';
            menu.src = menu.src + 'Contributors.png';
            menu.newSrc = menu.newSrc + 'User-Management.png';
            break;
        case 'repository':
          // menu.routerLink = '/home/repository-report';
          // menu.route = '/home/repository-report';
          menu.routerLink = '/repo';
          menu.route = '/repo';
          menu.name = 'Study Repository';
          menu.src = menu.src + 'repositiry_icon.png';
          menu.newSrc = menu.newSrc + 'Repository.png';
          break;
        case 'ama':
          menu.routerLink = '/ama';
          // menu.routerLinkActive = 'link-active';
          menu.routerLinkActiveOptions= {exact: false};
          menu.route = '/ama';
          menu.name = 'Ask IPSOS';
          menu.src = menu.src + 'ei-ama-icon@3x.png';
          menu.newSrc = menu.newSrc + 'survey_builder_icon.png';
          break;
        case 'mrsi':
            menu.routerLink = '/mrsi';
            // menu.routerLinkActive = 'link-active';
            menu.routerLinkActiveOptions= {exact: false,customWidth:true};
            menu.route = '/mrsi';
            menu.name = 'MRSI';
            menu.src = menu.src + 'mrsi@3x.png';
            menu.newSrc = menu.newSrc + 'cos_icon.png';
            break;
        case 'qc_dashboard':
            menu.routerLink = '/qa-report';
            // menu.routerLinkActive = 'link-active';
            menu.routerLinkActiveOptions= {exact: false};
            menu.route = '/qa-report/qa-dashboard';
            menu.name = 'iField QA Dashboard';
            menu.src = menu.src + 'qa_dashboard.png';
            menu.newSrc = menu.newSrc + 'ifield_qa_dash.png';
            break; 
        case 'trinity':
            menu.routerLink = '/trinity';
            // menu.routerLinkActive = 'link-active';
            menu.routerLinkActiveOptions= {exact: false};
            menu.route = '/trinity';
            menu.name = 'Trinity';
            menu.src = menu.src + 'trinity.png';
            menu.newSrc = menu.newSrc + 'trinity_icon.png';
            break;
        case 'express':
            menu.routerLink = '/express';
            // menu.routerLinkActive = 'link-active';
            menu.routerLinkActiveOptions= {exact: false};
            menu.route = '/express';
            menu.name = 'Express Insights';
            menu.src = menu.src + 'insight_insights.png';
            menu.newSrc = menu.newSrc + 'express.png';
            break;

        case 'client_master':
            menu.routerLink = '/client-master';
            // menu.routerLinkActive = 'link-active';
            menu.routerLinkActiveOptions= {exact: false};
            menu.route = '/client-master';
            menu.name = 'Client Master';
            menu.src = menu.src + 'client-master-logo.png';
            menu.newSrc = menu.newSrc + 'client_master.png';
            break;
        case 'contract':
          menu.routerLink = '/contract';
          menu.routerLinkActive = 'link-active';
          menu.routerLinkActiveOptions= {exact: false};
          menu.route = '/contract';
          menu.name = 'COS';
          menu.src = menu.src + 'contract.png';
          menu.newSrc = menu.newSrc + 'cos_icon.png';
          break;
        case 'superset_dashboard':
          menu.routerLink = '/dash-suite';
          menu.routerLinkActive = 'link-active';
          menu.routerLinkActiveOptions= {exact: false};
          menu.route = '/dash-suite';
          menu.name = 'Dashboard Suite';
          menu.src = menu.src + 'superset-dash.png';
          menu.newSrc = menu.newSrc + 'superset-dash.png';
          break;    
        case 'More':
          menu.route = '/more';
          menu.name = 'More';
          menu.src = menu.src + 'more.png';
          menu.newSrc = menu.newSrc + 'more.png';
          break;

        default:
            // console.error('Mapping for main menu not found');
        }
        if(menu.visibility && menu.name != ''){
          this.sideDrawer.mainMenu.push(menu);
        }
    }

    SetUserMenusDetails(key, value){
      let menu = new SubMenu();
      menu.visibility = value['view'];
      menu.routerLinkActive = 'link-active';
      menu.routerLinkActiveOptions = {exact: false};
      console.log("key ===> ",key)
      switch(key){
        case 'users':
          menu.name = 'Users';
          menu.routerLink = '/user-manager/users';
          menu.route = '/user-manager/users';
          break;

        // case 'client_master':
        //   menu.name = 'Client Master';
        //   menu.routerLink = '/user-manager/client-list';
        //   menu.route = '/user-manager/client-list';
        //   menu.visibility = value && value['view'];
        //   break;
        // case 'teams':
        //   menu.name = 'Teams';
        //   menu.routerLink = '/user-manager/teams';
        //   menu.route = '/user-manager/teams';
        //   break;
        case 'organizations':
          menu.name = 'Organization';
          menu.routerLink = '/user-manager/organization-list';
          menu.route = '/user-manager/organization-list';
          // menu.visibility = value && (this.access['access_rules'] && this.access['access_rules']['organizations'] && this.access['access_rules']['organizations']['view']);
          // menu.visibility = value && ((this.access['super'] && this.access['super'] == true) && this.access['org_name'] == 'Crownit');
          menu.visibility = value && value['view'] && (this.access['super'] && this.access['super'] == true);
          break;
        case 'unmapped_users':
          menu.name = 'Unmapped Users';
          menu.routerLink = '/user-manager/unmapped-users';
          menu.route = '/user-manager/unmapped-users';
          menu.visibility = value && value['view'];
          break;
        default:
          console.error('Mapping for sub menu not found ', key);
        }
        if(menu.visibility && menu.name != ''){
          this.sideDrawer.subMenu.push(menu);
        }
        console.log("this.sideDrawer.subMenu ===> ",this.sideDrawer.subMenu)
    }

    SetQualMenusDetails(key, value){
      let menu = new SubMenu();
      menu.visibility = value['view'];
      menu.routerLinkActive = 'link-active';
      menu.routerLinkActiveOptions= {exact: false};
      switch(key){
          case 'interview':
            menu.name = 'Interviews';
            menu.routerLink = '/qual/interview';
            menu.route = '/qual/interview';
            break;
          case 'report':
            menu.name = 'Reports';
            menu.routerLink = '/qual/report';
            menu.route = '/qual/report';
            break;
          default:
            // console.error('Mapping for sub menu not found');
        }
        if(menu.visibility && menu.name != ''){
          this.sideDrawer.subMenu.push(menu);
        }
    }

    pushToSubMenu(menu:SubMenu){
      let index = this.sideDrawer.subMenu.findIndex((menuN) => menuN['name'] == menu.name);
        if(index > -1){
          this.sideDrawer.subMenu[index] = menu;
        }else{
          this.sideDrawer.subMenu.push(menu);
        }
    }

    SetRepoMenusDetails(value, options?:any){
      // console.log('in repo in');
      
      // Guard: Check if projectDetails exists before accessing
      if (!this.reportService.projectDetails) {
        console.warn('ProjectDetails not loaded yet');
        return;
      }
      
      localStorage.setItem('reportdetails',JSON.stringify(this.reportService.projectDetails))
      let menuHeading = new SubMenu();
       menuHeading.visibility = value;
       menuHeading.name = "Repository";
       menuHeading.isSubMenuTitle = true;
       this.pushToSubMenu(menuHeading);

      let menu = new SubMenu();
      menu.visibility = value;
      menu.routerLinkActive = 'link-active';
      menu.routerLinkActiveOptions= {exact: false};

      if (this.reportService.projectDetails['project_name'] && 
          this.reportService.projectDetails['studies'] && 
          this.reportService.projectDetails['studies'].length > 0) {
        menu.name = this.reportService.projectDetails['project_name'];
        menu.routerLink = '/repo/details';
        menu.route = '/repo/details/'+this.reportService.projectDetails['studies'][0]['study_uuid'];
        this.sideDrawer.subMenu.push(menu);
      }

      // console.log("this.reportService.projectDetails['studies'] ===> ",this.reportService.projectDetails['studies'])
      // Guard: Check if studies array exists and has items before forEach
      if (this.reportService.projectDetails['studies'] && this.reportService.projectDetails['studies'].length > 0) {
        this.reportService.projectDetails['studies'].forEach(study => {
          let menu = new SubMenu();
          menu.visibility = value;
          menu.routerLinkActive = 'link-active';
          menu.routerLinkActiveOptions = {exact: true};
          menu.name = study['study_name'];
          menu.isTree = true;
          menu.isVioletTheme = true;
          // menu.route = 'reports-s';
          menu.dropdown_route = 'reports-s';
          menu.routerLink = '/repo/details/'+study['study_uuid'];
          menu.route = '/repo/details/'+study['study_uuid'];
          menu.dropDown = [];
          // menu.isDropdown = true;
          if (study['files'] && study['files'].length) {
            this.setDropdownFiles(menu,study['files']);
          }else{
            this.setDropdownEmptyFilesStudy(menu);
            // this.sideDrawer.subMenu.push(menu);
          }
        });
      }

      // Call Recording Studies Wise
      if(this.reportService.isCallRecording){
        this.setCallRecordingToSideBar();
      }

      

    }

    setCallRecordingToSideBar(){
      // Guard: Check if studies array exists before accessing
      if (!this.reportService.projectDetails || 
          !this.reportService.projectDetails['studies'] || 
          this.reportService.projectDetails['studies'].length === 0) {
        console.warn('Cannot set call recording - studies array is empty or undefined');
        return;
      }
      
      let menu = new SubMenu();
      menu.visibility = true;
      if(window.location.href.includes('call-recording')){
        menu.routerLinkActive = 'link-active';
      }
      menu.name = 'Call Recording';
      menu.routerLink = '/home/repository-report/call-recording/'+this.reportService.projectDetails['studies'][0]['study_uuid'];
      menu.route = '/home/repository-report/call-recording/'+this.reportService.projectDetails['studies'][0]['study_uuid'];
      this.sideDrawer.subMenu.push(menu);
    }




    SetCIMenusDetails(key, value){
      let menu = new SubMenu();
      if(key == 'icv_highlighter'){
        menu.visibility = value;
      }else{
        menu.visibility = value['view'];
      }
      menu.routerLinkActive = 'link-active';
      switch(key){
        case 'request_list':
            menu.name = 'Request List';
            menu.routerLink = '/consumer-immersions/request-list';
            menu.route = '/consumer-immersions/request-list';
            break;
          case 'interview_count':
            menu.name = 'Interview Count';
            menu.routerLink = '/consumer-immersions/interviews-count';
            menu.route = '/consumer-immersions/interviews-count';
            break;
          case 'credit_history':
            menu.name = 'Credits History';
            menu.routerLink = '/consumer-immersions/transactions';
            menu.route = '/consumer-immersions/transactions';
            menu.visibility = this.IsICVCreditFloW ? true : false
            break;
          case 'icv_highlighter':
            this.setIcvHighlighterMenu(menu);
            break;
          
          default:
            // console.error('Mapping for sub menu not found');
        }
        if(menu.visibility && menu.name != ''){
          this.sideDrawer.subMenu.push(menu);
        }
    }

    setIcvHighlighterMenu(menu){
      menu.highLighterCont = [
        {
          name:'About ICV',
          src:'../../../../assets/repository/icons/icv-info.png',
          type:'pdf'
        },
  
        {
          name:'How to use ICV',
          src:'../../../../assets/repository/icons/icv_demo_image.jpg',
          type:'video'
        },
      ];
      if(!this.isSidePanelCIVideoHighlighterShow){
        menu.highLighterCont = [
          {
            name:'About ICV',
            src:'../../../../assets/repository/icons/Vector.png',
            type:'pdf'
          },
        ]
      }
      
      menu.name = 'ICV';
      menu.isHighlighter = true;
    }


    SetQAReportMenu(key, value){
      let menu = new SubMenu();
      menu.visibility = value['view'];
      menu.routerLinkActive = 'link-active';
      switch(key){
        // case 'qa_dashboard':
          // case 'dashboard':
          //   menu.name = 'Dashboard';
          //   menu.routerLink = '/qa-report/qa-dashboard';
          //   menu.route = '/qa-report/qa-dashboard';
          //   break;
          case 'report':
          // case 'qa_report':
            menu.name = 'Report';
            menu.routerLink = '/qa-report/qa-report';
            menu.route = 'reports-s';
            menu.isDropdown = true;
            this.setDropdownQAReportGroups(menu,this.qaService.qaReportConfig)
            // this.setDropdownQAReportGroups(menu,[{"name":"Year on year"},{"name":"Zone"}])
            break;
          default:
            // console.error('Mapping for sub menu not found');
        }
        if(menu.visibility && menu.name != ''){
          this.sideDrawer.subMenu.push(menu);
          // console.log("this.sideDrawer.subMenu = ",this.sideDrawer.subMenu)
        }
    }

    SetPTTrackerMenu(key, value){
      let menu = new SubMenu();
      menu.visibility = value['view'];
      menu.routerLinkActive = 'link-active';
      switch(key){

        case 'pt_tracker':
            menu.name = 'PT Tracker';
            menu.routerLink = '/home/product-testing/'+this.homeService.ptDetails.pt_uuid;
            menu.route = '/home/product-testing/'+this.homeService.ptDetails.pt_uuid;
            break;
        case 'event_tracker':
          menu.name = 'View Events';
          menu.routerLink = '/home/pt-event/event/'+this.homeService.ptDetails.pt_uuid;
          menu.route = 'reports-s';
          // console.log("setting PT Event Groups");
          this.setDropdownPTEventGroups(menu,this.homeService.ptDetails.events || [])
          break;
          default:
        }
        if(menu.visibility && menu.name != ''){
          this.sideDrawer.subMenu.push(menu);
          // console.log("this.sideDrawer.subMenu = ",this.sideDrawer.subMenu)
        }
    }

    setDropdownPTEventGroups(menu:SubMenu,groups){
      menu.dropDown = [];
      menu.isVioletTheme = true;
      for (let i = 0; i < groups.length; i++) {
        if (groups[i] && groups[i].is_sidenav_event) {
          let dropMenu = new MenuDetails();
          dropMenu.route = '/home/pt-event/'+groups[i].event_route+'/'+groups[i].pt_uuid;
          dropMenu.routerLink = '/home/pt-event/'+groups[i].event_route+'/'+groups[i].pt_uuid;
          dropMenu.visibility = true;
          dropMenu.routerLinkActive = 'active';
          dropMenu.name = groups[i].name;
          dropMenu.src = "";
          dropMenu.style = {"padding-left":"30px"};
          menu.dropDown.push(dropMenu);
        }
      }
      // this.sideDrawer.subMenu.push(menu);
    }

    SetEagleliveMenusDetails(key, value){
      let menu = new SubMenu();
      menu.visibility = value['view'];
      menu.routerLinkActive = 'link-active';
      switch(key){
        case 'eagle_dashboard':
            menu.name = 'Dashboard';
            menu.routerLink = '/eagle-live/dashboard';
            menu.route = '/eagle-live/dashboard';
            break;
          case 'eagle_account_creation':
            menu.name = 'Account Creation';
            menu.routerLink = '/eagle-live/account-creation';
            menu.route = '/eagle-live/account-creation';
            break;
          case 'eagle_interview_creation':
            menu.name = 'Interview Creation';
            menu.routerLink = '/eagle-live/interview-creation';
            menu.route = '/eagle-live/interview-creation';
            break;
          case 'zoom_recording':
            menu.name = 'Zoom Recording';
            menu.routerLink = '/eagle-live/zoom-recordings';
            menu.route = '/eagle-live/zoom-recordings';
            menu.visibility = value['view'] && (this.access['super'] && this.access['super'] == true);
            break;
          case 'recording':
            menu.name = 'Recording';
            menu.routerLink = '/eagle-live/recordings';
            menu.route = '/eagle-live/recordings';
            break;
          default:
            // console.error('Mapping for sub menu not found');
        }
        if(menu.visibility && menu.name != ''){
          this.sideDrawer.subMenu.push(menu);
        }
    }

    setSubmenuLevel1(menu:SubMenu,itemObj:any[],parent){
      menu.isTree = true;
      let levelItemKeys = Object.keys(itemObj)
      for (let i = 0; i < levelItemKeys.length; i++) {
        let dropMenu = new MenuDetails();
        dropMenu.route = '/mrsi/event-list/'+itemObj[levelItemKeys[i]].id;
        dropMenu['filteres'] = []
        dropMenu.visibility = true;
        dropMenu.isTreeLevelOne = true;
        dropMenu.routerLinkActive = '/mrsi/event-list/'+itemObj[levelItemKeys[i]].id;
        // dropMenu.name = levelItemKeys[i];    
        dropMenu.name = ` (${this.getMrsiEventCountTreeLevel(parent,itemObj[levelItemKeys[i]])}) - ` + itemObj[levelItemKeys[i]]['name'];   
        dropMenu.uuid = itemObj[levelItemKeys[i]]['id'];    
        dropMenu.file = {parent:parent,selectedEvent:itemObj[levelItemKeys[i]]}
        dropMenu.routerLinkActiveOptions = {exact: false};
        // console.log(dropMenu,parent,i+1,'Great');   
        menu.dropDown.push(dropMenu);
      }
      this.sideDrawer.subMenu.push(menu);
    }

    SetMRSIMenusDetails(value){
      let events = Object.keys(this.mrsiService.mrsiEventList)
      if (events.length > 0) {
        for (let i = 0; i < events.length; i++) {
            let menu = new SubMenu();
            menu.visibility = value;
            menu.routerLinkActive = 'link-active';
            menu.name = events[i] + ` (${this.getMrsiEventCount(events[i])})`;
            menu.routerLink = '/event-list';
            menu.route = '/mrsi/event-list';
            menu.dropDown = [];
            // if (this.mrsiService.mrsiEventList[events[i]]) {
              
            // }
            // if(menu.visibility && menu.name != ''){
            //   this.sideDrawer.subMenu.push(menu);
            // }
            this.setSubmenuLevel1(menu,this.mrsiService.mrsiEventList[events[i]],events[i])
          if (i == events.length -1) {
            let menu = new SubMenu();
            menu.visibility = value;
            menu.routerLinkActive = 'link-active';
            menu.name = 'Overall Feedback' + ` (${this.getMrsiEventCount('feedback')})`;
            menu.routerLink = '/mrsi/overall-feedback';
            menu.route = '/mrsi/overall-feedback';
            if(menu.visibility && menu.name != ''){
              this.sideDrawer.subMenu.push(menu);
            }
          }
        }
      }else{
        let menu = new SubMenu();
        menu.visibility = value;
        menu.routerLinkActive = 'link-active';
        menu.name = 'Overall Feedback';
        menu.routerLink = '/mrsi/overall-feedback';
        menu.route = '/mrsi/overall-feedback';
        if(menu.visibility && menu.name != ''){
          this.sideDrawer.subMenu.push(menu);
        }
      }


      // let menu = new SubMenu();
      // menu.visibility = value;
      // menu.routerLinkActive = 'link-active';
      // let menu1 = new SubMenu();
      // menu1.visibility = value;
      // menu1.routerLinkActive = 'link-active';
      // menu1.name = 'event';
      // menu1.routerLink = '/mrsi/event-list';
      // menu1.route = '/mrsi/event-list';
      // this.sideDrawer.subMenu.push(menu1);
      // menu.name = 'Overall Feedback';
      // menu.routerLink = '/mrsi/overall-feedback';
      // menu.route = '/mrsi/overall-feedback';
      // if(menu.visibility && menu.name != ''){
      //   this.sideDrawer.subMenu.push(menu);
      // }

    }

    getMrsiEventCount(name){
      // console.log(name);
      if(name == 'feedback'){
        return this.mrsiEventListOverallCountDetails[name] ? this.mrsiEventListOverallCountDetails[name] :0;
      }else{
        if(Object.keys(this.mrsiEventListOverallCountDetails).length){
          return this.mrsiEventListOverallCountDetails[name] && this.mrsiEventListOverallCountDetails[name]['total'] ? this.mrsiEventListOverallCountDetails[name]['total'] : 0;
        }else{
          return 0;
        }
      }
    }


    getMrsiEventCountTreeLevel(key,obj){
      // console.log(key,obj);
      if(Object.keys(this.mrsiEventListOverallCountDetails).length){
        if(this.mrsiEventListOverallCountDetails[key] && Object.keys(this.mrsiEventListOverallCountDetails[key]).length){
          if(obj && obj.time){
            let subkey = obj.time.substring(0,8);
            return this.mrsiEventListOverallCountDetails[key][subkey] ? this.mrsiEventListOverallCountDetails[key][subkey] : 0;
          }
          // console.log(this.mrsiEventListOverallCountDetails[key],name,'Greate');
        }
        return 0;
      }else{
        return 0;
      }
      
      
    }

    SetHomeMenusDetailsWithStudyId(key, value){
      let isPerformance:boolean = false;
      let isBiReport:boolean = false;
      let isPannel:boolean = false;
      let isDiarySurvey:boolean = false;
      let isSurvey:boolean = false;
      let isSurveyPreview:boolean = false;
      let isFunnelReportBeta:boolean = false;
      let isTermReportBeta:boolean = false;
      let isUtmReportBeta:boolean = false;
      if(this.visibilityData != null){
        // console.log('datttta : ',this.visibilityData);
        isPerformance = this.visibilityData['performaceTracker'] && this.visibilityData['performaceTracker']['show'] ? true :false;
        isBiReport = this.visibilityData['biReport'] && this.visibilityData['biReport']['show'] ? true : false;
        isPannel = this.visibilityData['panelList']['show'];
        isSurvey =  this.visibilityData &&  this.visibilityData['survey'] && this.visibilityData['survey']['show'] ? true :false;
        isDiarySurvey = this.visibilityData && this.visibilityData['dairy-survey'] && this.visibilityData['dairy-survey']['show'] ? true : false;
        isSurveyPreview =  this.visibilityData &&  this.visibilityData['survey-preview'] && this.visibilityData['survey-preview']['show'] ? true :false;
        isFunnelReportBeta =  this.visibilityData &&  this.visibilityData['funnelReport-beta'] && this.visibilityData['funnelReport-beta']['show'] ? true :false;
        isUtmReportBeta =  this.visibilityData &&  this.visibilityData['utmReport-beta'] && this.visibilityData['utmReport-beta']['show'] ? true :false;
        isTermReportBeta =  this.visibilityData &&  this.visibilityData['termReport-beta'] && this.visibilityData['termReport-beta']['show'] ? true :false;
      }


      //for Submenu Title
        let menuHeading = new SubMenu();
        menuHeading.visibility = value;
        menuHeading.name = "Dashboard";
        menuHeading.isSubMenuTitle = true;
        // menuHeading.newSrc += 'Home(Dashboard).png';
        this.pushToSubMenu(menuHeading);


      let menu = new SubMenu();
      menu.visibility = value['view'];
      menu.routerLinkActive = 'link-active';
      menu.routerLinkActiveOptions= {exact: false};
      switch(key){
        case 'performance_panel':
            menu.name = 'Performance Tracker';
            menu.routerLink = '/home/performance-tracker/'+this.studyId;
            menu.route = '/home/performance-tracker/'+this.studyId;
            menu.visibility = this.access && this.access['account_type'] && this.access['account_type'] == 'Master' ? true : this.isDemoUserWithSuperAccess ? (this.initFor && this.initFor != 'qual'  ? true : false ) : ((value['view'] || isPerformance) && (this.initFor == 'home' || (this.initFor == 'qual' && this.access['super'] && this.access['super'] == true) ));
            break;
          // case 'panel_list':
          //   menu.name = 'Panel List';
          //   menu.routerLink = '/home/panel-list/'+this.studyId;
          //   menu.route = '/home/panel-list/'+this.studyId;
          //   menu.visibility = this.isDemoUserWithSuperAccess ? false : (value['view'] &&  ((this.access['super'] && this.access['super'] == true ) || isPannel)) ? true : isPannel && this.checkStudyAcess('panel_list')  ? true : false;
          //   break;

          case 'survey':
            menu.name = 'Survey';
            menu.routerLink = '/home/research-survey/'+this.studyId;
            menu.route = 'survey-builder';
            menu.visibility = ((this.access['super'] && this.access['super'] == true) && this.initFor && this.initFor != 'qual')
            ? true : ((isSurvey || isSurveyPreview) && this.initFor && this.initFor != 'qual') ? true : false;
            this.setSurveyMenu(menu,isSurvey,isSurveyPreview);
            break;  
        
          // case 'recruiter':
          //   menu.name = 'Recruiter List';
          //   menu.routerLink = '/home/projects/dashboard/'+this.studyId;
          //   menu.route = '/home/projects/dashboard/'+this.studyId;
          //   menu.visibility = this.isDemoUserWithSuperAccess ? false : (value['view'] && ((this.initFor && this.initFor == 'home' || this.initFor == 'qual') && (this.access['super'] && this.access['super'] == true )));
          //   break;
          case 'analysis_report':
            menu.name = 'Analysis Report';
            menu.routerLink = '/home/analysis-report/'+this.studyId;
            menu.route = '/home/analysis-report/'+this.studyId;
            menu.visibility = this.isDemoUserWithSuperAccess ? false : (value['view'] ||  (this.access['super'] && this.access['super'] == true )) && false;
            break;
          case 'biReport':
            menu.name = 'BI Report';
            menu.routerLink = '/home/bi-report/'+this.studyId;
            menu.route = '/home/bi-report/'+this.studyId;
            menu.visibility = this.isDemoUserWithSuperAccess ? false : value['view'] && (this.access['super'] && this.access['super'] == true) ? true : isBiReport && this.checkStudyAcess('biReport') ? true : false;
            break;
          case 'visibility_control':
            menu.name = 'Visibility Control';
            menu.routerLink = '/home/visibility/'+this.studyId;
            menu.route = '/home/visibility/'+this.studyId;
            menu.visibility = this.isDemoUserWithSuperAccess ? false :(value['view'] && ((this.initFor && (this.initFor == 'home' || this.initFor == 'qual')))) && (this.access['super'] && this.access['super'] == true ) ? true : false;
            break;
          case 'funnel_report':
            menu.name = 'Reports';
            menu.routerLink = '/home/funnel-report/'+this.studyId;
            menu.route = 'reports-s';
            menu.visibility = (value['view'] && ((this.initFor && (this.initFor == 'home' || this.initFor == 'qual') ))) && (this.access['super'] && this.access['super'] == true ) 
            ? true : (((isFunnelReportBeta  || isUtmReportBeta ||  isTermReportBeta) && this.checkStudyAcess('funnel_report')) && (this.initFor && (this.initFor == 'home' || this.initFor == 'qual')))
            ? true : this.access && this.access['account_type'] && this.access['account_type'] == 'Master' ? true  : false;
            this.setDropdown(menu,isFunnelReportBeta,isUtmReportBeta,isTermReportBeta);
            break;
     
          case 'interview':
            menu.name = 'Interviews';
            menu.routerLink = '/qual/interview/'+this.studyId;
            menu.route = '/qual/interview/'+this.studyId;
            menu.visibility = this.isDemoUserWithSuperAccess ? (this.initFor && this.initFor == 'qual' ? true : false ) : value['view'] && (this.initFor && this.initFor == 'qual' );
            break;
          case 'qual_report':
            menu.name = 'Qual Video';
            menu.routerLink = '/qual/report/'+this.studyId;
            menu.route = '/qual/report/'+this.studyId;
            menu.visibility = this.isDemoUserWithSuperAccess ? (this.initFor && this.initFor == 'qual' ? true : false ) : value['view'] && (this.initFor && this.initFor == 'qual' );
            break;
          case 'survey-Dairy':
            menu.name = 'Dairy Dashboard';
            menu.routerLink = '/home/dairy-dashboard';
            menu.route = 'digital-survey';
            menu.visibility = (this.access['super'] && this.access['super'] == true && this.initFor && this.initFor != 'qual') 
            ? true : !(this.access['super'] && this.access['super'] == true) || isDiarySurvey ? true : false
            this.setDiaryDropDown(menu);
            break;  
          case 'call-Recording':
            menu.name = 'Call Recording';
            menu.routerLink = '/home/repository-report/call-recording';
            menu.route = 'call-recording';
            menu.visibility = (this.access['super'] && this.access['super'] == true && this.initFor && this.initFor == 'qual');
            break;    
          default:
        }
        if(menu.visibility && menu.name != ''){
          this.pushToSubMenu(menu);
        }
       
        
        
    }

    SetHomeMenusDetails(key, value){
      let isPerformance:boolean = false;
      let isBiReport:boolean = false;
      let isPannel:boolean = false;
      let isDiarySurvey:boolean = false;
      let isSurvey:boolean = false;
      let isSurveyPreview:boolean = false;
      let isFunnelReportBeta:boolean = false;
      let isTermReportBeta:boolean = false;
      let isUtmReportBeta:boolean = false;
      let isSupersetStudy:boolean = false;
      let supersetEls:any = {};
      if(this.visibilityData != null){
        // console.log('datttta : ',this.visibilityData);
        isPerformance = this.visibilityData['performaceTracker'] && this.visibilityData['performaceTracker']['show'] ? true :false;
        isBiReport = this.visibilityData['biReport'] && this.visibilityData['biReport']['show'] ? true : false;
        isPannel = this.visibilityData['panelList'] && this.visibilityData['panelList']['show'] ? true : false;
        isSurvey =  this.visibilityData &&  this.visibilityData['survey'] && this.visibilityData['survey']['show'] ? true :false;
        isDiarySurvey = this.visibilityData && this.visibilityData['dairy-survey'] && this.visibilityData['dairy-survey']['show'] ? true : false;
        isSurveyPreview =  this.visibilityData &&  this.visibilityData['survey-preview'] && this.visibilityData['survey-preview']['show'] ? true :false;
        isFunnelReportBeta =  this.visibilityData &&  this.visibilityData['funnelReport-beta'] && this.visibilityData['funnelReport-beta']['show'] ? true :false;
        isUtmReportBeta =  this.visibilityData &&  this.visibilityData['utmReport-beta'] && this.visibilityData['utmReport-beta']['show'] ? true :false;
        isTermReportBeta =  this.visibilityData &&  this.visibilityData['termReport-beta'] && this.visibilityData['termReport-beta']['show'] ? true :false;
        isSupersetStudy = this.visibilityData && this.visibilityData['superset'] && this.visibilityData['superset']['show'] ? true : false;
        supersetEls = this.visibilityData && this.visibilityData['superset'] && this.visibilityData['superset']['els'] ? this.visibilityData['superset']['els'] : {};
      }
      


      //for Submenu Title
        let menuHeading = new SubMenu();
        menuHeading.visibility = value;
        menuHeading.name = "Dashboard";
        menuHeading.isSubMenuTitle = true;
        // menuHeading.newSrc += 'Home(Dashboard).png';
        // let headindex = this.sideDrawer.subMenu.findIndex((menuN) => menuN['name'] == menuHeading.name);
        //   if(headindex > -1){
        //     this.sideDrawer.subMenu[headindex] = menuHeading;
        //   }else{
        //     this.sideDrawer.subMenu.push(menuHeading);
        //   }
        this.pushToSubMenu(menuHeading);
        // this.sideDrawer.subMenu[0] = menuHeading;



      // console.log("key ==>",key)
      // console.log("value ==>",value)
      let menu = new SubMenu();
      menu.visibility = value['view'];
      menu.routerLinkActive = 'link-active';
      menu.routerLinkActiveOptions= {exact: false};
      switch(key){
        case 'performance_panel':
            menu.name = 'Performance Tracker';
            menu.routerLink = '/home/performance-tracker';
            menu.route = '/home/performance-tracker';
            menu.visibility = this.access && this.access['account_type'] && this.access['account_type'] == 'Master' ? true : this.isDemoUserWithSuperAccess ? (this.initFor && this.initFor != 'qual'  ? true : false ) : ((value['view'] || isPerformance) && (this.initFor == 'home' || (this.initFor == 'qual' && this.access['super'] && this.access['super'] == true) ));
            break;
          // case 'panel_list':
          //   menu.name = 'Panel List';
          //   menu.routerLink = '/home/panel-list';
          //   menu.route = '/home/panel-list';
          //   menu.visibility = this.isDemoUserWithSuperAccess ? false : (value['view'] &&  ((this.access['super'] && this.access['super'] == true ) || isPannel)) ? true : isPannel && this.checkStudyAcess('panel_list')  ? true : false;
          //   break;

          case 'survey':
            menu.name = 'Survey';
            menu.routerLink = '/home/research-survey';
            menu.route = 'survey-builder';
            menu.visibility = ((this.access['super'] && this.access['super'] == true) && this.initFor && this.initFor != 'qual')
            ? true : ((isSurvey || isSurveyPreview) && this.initFor && this.initFor != 'qual') ? true : false;
            this.setSurveyMenu(menu,isSurvey,isSurveyPreview);
            break;  
        
          // case 'recruiter':
          //   menu.name = 'Recruiter List';
          //   menu.routerLink = '/home/projects/dashboard';
          //   menu.route = '/home/projects/dashboard';
          //   menu.visibility = this.isDemoUserWithSuperAccess ? false : (value['view'] && ((this.initFor && this.initFor == 'home' || this.initFor == 'qual') && (this.access['super'] && this.access['super'] == true )));
          //   break;
          case 'analysis_report':
            menu.name = 'Analysis Report';
            menu.routerLink = '/home/analysis-report';
            menu.route = '/home/analysis-report';
            menu.visibility = this.isDemoUserWithSuperAccess ? false : (value['view'] ||  (this.access['super'] && this.access['super'] == true )) && false;
            break;
          case 'biReport':
            menu.name = 'BI Report';
            menu.routerLink = '/home/bi-report';
            menu.route = '/home/bi-report';
            menu.visibility = this.isDemoUserWithSuperAccess ? false : value['view'] && (this.access['super'] && this.access['super'] == true) ? true : isBiReport && this.checkStudyAcess('biReport') ? true : false;
            break;
          case 'visibility_control':
            menu.name = 'Visibility Control';
            menu.routerLink = '/home/visibility';
            menu.route = '/home/visibility';
            menu.visibility = this.isDemoUserWithSuperAccess ? false :(value['view'] && ((this.initFor && (this.initFor == 'home' || this.initFor == 'qual')))) && (this.access['super'] && this.access['super'] == true ) ? true : false;
            break;
          case 'funnel_report':
            menu.name = 'Reports';
            menu.routerLink = '/home/funnel-report';
            menu.route = 'reports-s';
            menu.visibility = (value['view'] && ((this.initFor && (this.initFor == 'home' || this.initFor == 'qual') ))) && (this.access['super'] && this.access['super'] == true ) 
            ? true : (((isFunnelReportBeta  || isUtmReportBeta ||  isTermReportBeta) && this.checkStudyAcess('funnel_report')) && (this.initFor && (this.initFor == 'home' || this.initFor == 'qual')))
            ? true : this.access && this.access['account_type'] && this.access['account_type'] == 'Master' ? true  : false;
            this.setDropdown(menu,isFunnelReportBeta,isUtmReportBeta,isTermReportBeta);
            break;
     
          case 'interview':
            menu.name = 'Interviews';
            // menu.routerLink = '/home/qual/interview';
            // menu.route = '/home/qual/interview';
            menu.routerLink = '/qual/interview';
            menu.route = '/qual/interview';
            menu.visibility = this.isDemoUserWithSuperAccess ? (this.initFor && this.initFor == 'qual' ? true : false ) : value['view'] && (this.initFor && this.initFor == 'qual' );
            break;
          case 'qual_report':
            menu.name = 'Qual Video';
            // menu.routerLink = '/home/qual/report';
            // menu.route = '/home/qual/report';
            menu.routerLink = '/qual/report';
            menu.route = '/qual/report';
            menu.visibility = this.isDemoUserWithSuperAccess ? (this.initFor && this.initFor == 'qual' ? true : false ) : value['view'] && (this.initFor && this.initFor == 'qual' );
            break;
          case 'survey-Dairy':
            menu.name = 'Dairy Dashboard';
            menu.routerLink = '/home/dairy-dashboard';
            menu.route = 'digital-survey';
            menu.visibility = (this.access['super'] && this.access['super'] == true && this.initFor && this.initFor != 'qual') 
            ? true : !(this.access['super'] && this.access['super'] == true) || isDiarySurvey ? true : false
            this.setDiaryDropDown(menu);
            break;  
          case 'call-Recording':
            menu.name = 'Call Recording';
            menu.routerLink = '/home/repository-report/call-recording';
            menu.route = 'call-recording';
            menu.visibility = (this.access['super'] && this.access['super'] == true && this.initFor && this.initFor == 'qual');
            break;
          case 'superset_study':
            menu.name = 'Dashboard Suite';
            menu.routerLink = '/home/dash-suite';
            menu.route = '/home/dash-suite';
            menu.visibility = this.initFor && (this.initFor == 'home' || this.initFor == 'qual') ? true : false;
            break;    
          default:
            // console.error('Mapping for sub menu not found';
        }
        if(menu.visibility && menu.name != ''){
          // let index = this.sideDrawer.subMenu.findIndex((menuN) => menuN['name'] == menu.name);
          // if(index > -1){
          //   this.sideDrawer.subMenu[index] = menu;
          // }else{
          //   this.sideDrawer.subMenu.push(menu);
          // }

          this.pushToSubMenu(menu);
          // console.log('menu : ', this.sideDrawer.subMenu);
        }
       
        
        
    }


    checkStudyAcess(key){
      if(this.access && this.access['access_rules'] && this.access['access_rules']['study']){
        return this.access['access_rules']['study'][key] && this.access['access_rules']['study'][key]['view'] ? true : false 
      }
      return false;
    }

    setDropdown(menu:SubMenu,isFunnelReportBeta?,isUtmReportBeta?,isTermReportBeta?){
      let isSuper = this.access['super'] && this.access['super'] == true ? true : false;
      let isMasterAccount = this.access['account_type'] && this.access['account_type'] == 'Master' ? true : false;
      menu.dropDown = [];
      if(isSuper || isMasterAccount || isFunnelReportBeta){
        let dropMenu = new MenuDetails();
        dropMenu.visibility = true;
        dropMenu.routerLinkActive = 'active';
        dropMenu.name = 'Funnel Report (Beta)';
        dropMenu.routerLink = '/home/funnel-report';
        dropMenu.route = '/home/funnel-report';
        dropMenu.src = '/assets/images/funnel_report.png';
        menu.dropDown.push(dropMenu);
      }
      if(isSuper || isMasterAccount || isTermReportBeta){
        let dropMenu = new MenuDetails();
        dropMenu.visibility = true;
        dropMenu.routerLinkActive = 'active';
        dropMenu.name = 'Term Report (Beta)';
        dropMenu.routerLink = '/home/term-report';
        dropMenu.route = '/home/term-report';
        dropMenu.src = '/assets/images/term_report.png';
        menu.dropDown.push(dropMenu);
      }
      if(isSuper || isMasterAccount || isUtmReportBeta){
        let dropMenu = new MenuDetails();
        dropMenu.visibility = true;
        dropMenu.routerLinkActive = 'active';
        dropMenu.name = 'UTM Report (Beta)';
        dropMenu.routerLink = '/home/utm-report';
        dropMenu.route = '/home/utm-report';
        dropMenu.src = '/assets/images/utm_report.png';
        menu.dropDown.push(dropMenu);
      }
    }

    setDiaryDropDown(menu:SubMenu){
      menu.dropDown = [];
      let dropMenu = new MenuDetails();
      dropMenu.visibility = true;
      dropMenu.routerLinkActive = 'active';
      dropMenu.name = 'Day Wise';
      dropMenu.routerLink = '/home/dairy-dashboard/day-wise';
      dropMenu.route = '/home/dairy-dashboard/day-wise';
      dropMenu.src = '/assets/images/daywise.png';
      menu.dropDown.push(dropMenu);
      dropMenu = new MenuDetails();
      dropMenu.visibility = true;
      dropMenu.routerLinkActive = 'active';
      dropMenu.name = 'Center Wise';
      dropMenu.routerLink = '/home/dairy-dashboard/center-wise';
      dropMenu.route = '/home/dairy-dashboard/center-wise';
      dropMenu.src = '/assets/images/centerwise.png';
      menu.dropDown.push(dropMenu);
    }

    

    setSurveyMenu(menu,isSurvey,isSurveyPreview){
      menu.dropDown = [];
      let dropMenu = new MenuDetails();
      if(isSurvey || (this.access['super'] && this.access['super'] == true)){
        dropMenu.visibility = true;
        dropMenu.routerLinkActive = 'active';
        dropMenu.name = 'Survey Edit';
        dropMenu.routerLink = '/home/research-survey';
        dropMenu.route = '/home/research-survey';
        dropMenu.src = '/assets/images/edit.png';
          menu.dropDown.push(dropMenu);
      }
      if(isSurveyPreview || (this.access['super'] && this.access['super'] == true)){
        dropMenu = new MenuDetails();
        dropMenu.visibility = true;
        dropMenu.routerLinkActive = 'active';
        dropMenu.name = 'Survey Preview';
        dropMenu.routerLink = '/home/survey';
        dropMenu.route = '/home/survey';
        dropMenu.src = '/assets/images/term_report.png';
        menu.dropDown.push(dropMenu);
      }
    }

    setDropdownFiles(menu:SubMenu,files){
      // menu.dropDown = [];
      menu.isTree = true;
      for (let i = 0; i < files.length; i++) {
        let dropMenu = new MenuDetails();
        dropMenu.route = 'drop_level_1'
        dropMenu['filteres'] = []
        dropMenu.visibility = true;
        dropMenu.routerLinkActive = 'repo/file-view/'+files[i].file_uuid;
        // dropMenu.routerLinkActive = 'home/repository-report/file-view/'+files[i].file_uuid;
        dropMenu.name = files[i].name;
        dropMenu.uuid = files[i].file_uuid;
        dropMenu.file = files[i];
        // dropMenu.isDropdownItems = true;
        if (files[i]['filter_data'] && files[i]['filter_data'].length) {
          dropMenu.isTreeLevelOne = true;
          for (let j = 0; j < files[i]['filter_data'].length; j++) {
            dropMenu['filteres'].push(files[i]['filter_data'][j])
          }
        }
        menu.dropDown.push(dropMenu);
      }
      // this.sideDrawer.subMenu.push(menu);
      this.pushToSubMenu(menu);
      // let index = this.sideDrawer.subMenu.findIndex((menuN) => menuN['name'] == menu.name);
      // if(index > -1){
      //   this.sideDrawer.subMenu[index] = menu;
      // }else{
      //   this.sideDrawer.subMenu.push(menu);
      // }
    }

    setDropdownQAReportGroups(menu:SubMenu,groups){
      menu.dropDown = [];
      menu.isVioletTheme = true;
      for (let i = 0; i < groups.length; i++) {
        let dropMenu = new MenuDetails();
        dropMenu.route = '/qa-report/'+groups[i].sheet_key
        dropMenu.routerLink = '/qa-report/'+groups[i].sheet_key;
        dropMenu.visibility = true;
        dropMenu.routerLinkActive = 'active';
        dropMenu.name = groups[i].name;
        dropMenu.src = "";
        menu.dropDown.push(dropMenu);
      }
      // this.sideDrawer.subMenu.push(menu);
    }

    setDropdownEmptyFilesStudy (menu) {
      menu.isTree = true;
      let dropMenu = new MenuDetails();
        dropMenu.route = 'drop_level_1'
        dropMenu['filteres'] = []
        dropMenu.visibility = true;
        // dropMenu.routerLinkActive = 'home/repository-report/uuid';
        dropMenu.routerLinkActive = 'repo/report/uuid';
        dropMenu.name = 'No Files Found';
        dropMenu.file = {};
        dropMenu.file.name = 'No Files Found';
        menu.dropDown.push(dropMenu);
      this.pushToSubMenu(menu);
    }

    navigateMenu(route:string,index?:number,option?:any){
      // this.switchGlobalSearch(route.includes('repository-report') ? false: true);
      this.switchGlobalSearch(route.includes('repo') || route.includes('topline') ? false: true);
      this.studyId = this.router.url.split('/')[this.router.url.split('/').length - 1];
      this.studyId = this.studyId.split('?key')[0];
      // if(localStorage.getItem('studyId')){
      //   this.studyId = localStorage.getItem('studyId');
      // }
      if(sessionStorage.getItem('studyId')){
        this.studyId = sessionStorage.getItem('studyId');
      }
      // console.log("Study id ===>",this.studyId)
      switch(route){

        case 'more':
          break;
        case 'digital-survey':
          this.switchDropdown(index);
          break; 
        case 'survey-builder':
          this.switchDropdown(index);
          break;
        case 'reports-s':
          this.switchDropdown(index);
          break; 
        case '/mrsi/event-list':
          this.switchDropdown(index);
          break;
        case 'drop_level_1':
          this.switchDropdownLevel1(index,option);
          break;
        case '/home/performance-tracker':
        case '/home/bi-report':
        case '/home/funnel-report':
        case '/home/term-report':
        case '/home/utm-report':
        case '/home/summary-report':
        case '/home/projects/dashboard':
        case '/home/panel-list':
        case '/home/visibility':
        case '/home/dash-suite':
        case '/qual/interview':
        case '/qual/report':
        // case '/home/qual/interview':
        // case '/home/qual/report':
        // case '/home/dairy-dashboard':
        case '/home/dairy-dashboard/day-wise':  
        case '/home/dairy-dashboard/center-wise':  
        case '/home/research-survey':
          this.router.navigate([route, this.studyId]);
          break;
        case '/home/survey':
          if(localStorage.getItem('SurveyId') && localStorage.getItem('prevChannel')){
            let surveyId = localStorage.getItem('SurveyId');
            let prevChannel = localStorage.getItem('prevChannel');
            this.router.navigate([`/home/survey/${surveyId}/${prevChannel}`]);
            this.isSurveyPreviewFromResearch = true;
            break;
          }
        default:
          this.router.navigate([route]);
      }
    }

    /**
     * Keep the superset dropdown open when navigating between superset sub-menu items
     */
    keepSupersetDropdownOpen(): void {
      const supersetMenu = this.sideDrawer.subMenu.find(menu => menu.name === 'Superset Dashboard');
      if (supersetMenu) {
        supersetMenu.isDropdown = true;
      }
    }

    keepDashboardDropdownClosed(): void {
      let arr = new Set(['Superset Dashboard']);

      this.sideDrawer.subMenu.forEach(menu => {
        // console.log('menu.name : ', menu.name);
        if (arr.has(menu.name)) {
          menu.isDropdown = false;
        }
      });
    }

    openNewTab() {
      window.open('https://eagleinsights.in');
    }


    navigateToSurvey(){
      const currentUrl = this.router.url;
      let url = currentUrl.split('/');
      let studyId = url[url.length-1];
      this.router.navigateByUrl(`home/ResearchSurveyBuilder/${studyId}`);
    }

    switchDropdown(index){
      this.sideDrawer.subMenu[index].isDropdown = !this.sideDrawer.subMenu[index].isDropdown;
    }

    switchDropdownLevel1(index,option){
      this.sideDrawer.subMenu[index]['dropDown'][option['di']].isDropdownItems = !this.sideDrawer.subMenu[index]['dropDown'][option['di']].isDropdownItems;
    }


    homeDashboardAfterLogin(){
      this.sideDrawer = new SideDrawer();
      this.initSideDrawer('home');
    }

    afterLoginNavigate(){
      this.sideDrawer = new SideDrawer();
      // this.access = JSON.parse(localStorage.getItem('access'));
      const { redirect } = window.history.state;
      // console.log('After Login Previous URL',redirect);
      let routerURL:string = "";
      routerURL = this.setSideDrower(routerURL);
      // if(this.access['access_rules']['side_drawer']['repository']){
      //   routerURL = '/home/repository-report';
      //   this.initSideDrawer('home');
      // }else if(this.access['access_rules']['side_drawer']['dashboard']){
      //   routerURL = '/home/dashboard';
      //   this.initSideDrawer('home');
      // }else if(this.access['access_rules']['side_drawer']['projects']){
      //   routerURL = '/home/projects';
      //   this.initSideDrawer('home');
      // }else if(this.access['access_rules']['side_drawer']['manage_recuiters']){
      //   routerURL = '/home/recruiters';
      //   this.initSideDrawer('home');
      // }else if(this.access['access_rules']['side_drawer']['eaglelive']){
      //   routerURL = '/eagle-live/dashboard';
      //   this.initSideDrawer('eaglelive');
      // }else if(this.access['access_rules']['side_drawer']['consumer_immersions']){
      //   routerURL = '/consumer-immersions/request-list';
      //   this.initSideDrawer('ci');
      // }else if(this.access['access_rules']['side_drawer']['user_management']){
      //   routerURL = '/user-manager/users';
      //   this.initSideDrawer('user');
      // }else if(this.access['access_rules']['side_drawer']['survey_builder']){
      //   routerURL = '/surveys/listing';
      //   this.initSideDrawer('survey');
      // }else{
      //   this.notifier.notify('error','You are not authorized')
      // }
      // console.log("redirect =====> ", redirect);
      if(redirect && !redirect.includes('login')) {
        routerURL = redirect;
      }
      // console.log("routerURL ====> ", routerURL);
      if (!redirect && routerURL != '') {
        this.router.navigate(['home-dashboard']);
      }else if(routerURL != ''){
        setTimeout(()=>{
          this.router.navigate([routerURL]);
        // console.log(routerURL,'routerURL');
        })
      }
    }

    setSideDrower(routerURL) {
      this.access = JSON.parse(localStorage.getItem('access'));
      // console.log('access : ',this.access);
      if(this.access['access_rules']['side_drawer']['repository']){
        // routerURL = '/home/repository-report';
        routerURL = '/repo';
        this.initSideDrawer('home');
        // this.initSideDrawer('repo');
      }else if(this.access['access_rules']['side_drawer']['dashboard']){
        routerURL = '/home/dashboard';
        this.initSideDrawer('home');
      }else if(this.access['access_rules']['side_drawer']['projects']){
        routerURL = '/home/projects';
        this.initSideDrawer('home');
      }else if(this.access['access_rules']['side_drawer']['manage_recuiters']){
        routerURL = '/home/recruiters';
        this.initSideDrawer('home');
      }else if(this.access['access_rules']['side_drawer']['eaglelive']){
        routerURL = '/eagle-live/dashboard';
        this.initSideDrawer('eaglelive');
      }else if(this.access['access_rules']['side_drawer']['consumer_immersions']){
        routerURL = '/consumer-immersions/request-list';
        this.initSideDrawer('ci');
      }else if(this.access['access_rules']['side_drawer']['user_management']){
        routerURL = '/user-manager/users';
        this.initSideDrawer('user');
      }else if(this.access['access_rules']['side_drawer']['survey_builder']){
        routerURL = '/surveys/listing';
        this.initSideDrawer('survey');
      }else if(this.access['access_rules']['side_drawer']['mrsi']){
        routerURL = '/mrsi';
        this.initSideDrawer('mrsi');
      }else if(this.access['access_rules']['side_drawer']['contract']){
        routerURL = '/contract';
        this.initSideDrawer('contract');
      }else if(this.access['access_rules']['side_drawer']['express']){
        routerURL = '/express';
        this.initSideDrawer('express');
      }else if(this.access['access_rules']['side_drawer']['superset_dashboard']){
        routerURL = '/dash-suite';
        this.initSideDrawer('superset_dashboard');
      }
      else{
        this.notifier.notify('error','You are not authorized')
      }
      return routerURL;
    }

    navigateStudy(studyID){
      let flag = false;
      let URL = 'home/dashboard';
      this.sideDrawer.subMenu.forEach(menu => {
        if(menu.visibility && !flag && menu.route && menu.route != ''){
          flag = true;
          this.router.navigate([menu.route, studyID]);
          URL = menu.route;
        }
      });
      if(flag){
        this.router.navigate([URL,studyID]);
      }else{
        this.router.navigate([URL]);
        this.notifier.notify('error','Access Denied.');
      }
    }
    
  logout() {
    this.LogoutService.logout().subscribe(data => {
    });
    localStorage.clear();
    this.access = {};
    this.sideDrawer = null;
    this.studyId = '';
    this.initFor = '';
    this.router.navigate(['/login']);
  }

  openSubMenuHighlighter(type){
    this.dialog.open(IcvDemoVideoComponent,{
      data:{type:type},
      width:'72vw',
      height:'90vh',
    })

  }

  /**
   * Check if visibility data is cached and still valid for a study
   */
  isVisibilityCached(studyID: string): boolean {
    const cached = this.visibilityCache.get(studyID);
    if (!cached) return false;
    const now = Date.now();
    return (now - cached.timestamp) < this.CACHE_DURATION_MS;
  }

  /**
   * Get cached visibility data for a study (returns null if not cached or expired)
   */
  getCachedVisibility(studyID: string): any {
    if (this.isVisibilityCached(studyID)) {
      return this.visibilityCache.get(studyID)?.data || null;
    }
    return null;
  }

  /**
   * Invalidate visibility cache for a specific study or all studies
   * Call this when visibility settings are saved/updated
   */
  invalidateVisibilityCache(studyID?: string): void {
    if (studyID) {
      this.visibilityCache.delete(studyID);
      this.visibilityLoadingMap.delete(studyID);
    } else {
      this.visibilityCache.clear();
      this.visibilityLoadingMap.clear();
    }
  }

  /**
   * Apply visibility data to update home menu
   */
  private applyVisibilityToMenu(): void {
    if (this.visibilityData && this.visibilityData['performaceTracker'] && this.visibilityData['performaceTracker']['show']) {
      this.SetHomeMenusDetails('performance_panel', true);
    }
    if (this.visibilityData && this.visibilityData['panelList'] && this.visibilityData['panelList']['show']) {
      this.SetHomeMenusDetails('panel_list', true);
    }
    if (this.visibilityData && this.visibilityData['biReport'] && this.visibilityData['biReport']['show']) {
      this.SetHomeMenusDetails('biReport', true);
    }
    if (this.visibilityData && this.visibilityData.survey && this.visibilityData.survey.show) {
      this.SetHomeMenusDetails('survey', true);
    }
    if (
      (this.visibilityData && this.visibilityData['funnelReport-beta'] && this.visibilityData['funnelReport-beta'].show) ||
      (this.visibilityData && this.visibilityData['utmReport-beta'] && this.visibilityData['utmReport-beta'].show) ||
      (this.visibilityData && this.visibilityData['termReport-beta'] && this.visibilityData['termReport-beta'].show)
    ) {
      this.SetHomeMenusDetails('funnel_report', true);
    }
    // Superset Dashboard visibility
    if (this.visibilityData && this.visibilityData['superset'] && this.visibilityData['superset'].show) {
      this.SetHomeMenusDetails('superset_study', true);
    }
    
  }

  /**
   * Apply default menu when no visibility data exists
   */
  private applyDefaultMenu(): void {
    this.isFunnelReport = false;
    this.isTermReport = false;
    this.isUtmReport = false;
    this.SetHomeMenusDetails('performance_panel', false);
    this.SetHomeMenusDetails('panel_list', false);
    this.SetHomeMenusDetails('biReport', false);
    this.SetHomeMenusDetails('superset_study', false);
    if (this.access && this.access['access_rules'] && this.access['access_rules']['study']) {
      Object.keys(this.access['access_rules']['study']).forEach((Skey) => {
        this.SetHomeMenusDetails(Skey, this.access['access_rules']['study'][Skey]);
      });
    }
    if (this.access && this.access['access_rules'] && this.access['access_rules']['sub_side_drawer']) {
      Object.keys(this.access['access_rules']['sub_side_drawer']).forEach((Skey) => {
        this.SetHomeMenusDetails(Skey, this.access['access_rules']['sub_side_drawer'][Skey]);
      });
    }
  }

  /**
   * Get visibility for a study with caching support
   * @param studyID - Study ID to fetch visibility for
   * @param optional - Optional parameter ('navigate' to navigate after fetch)
   * @param forceRefresh - Force API call ignoring cache (use after visibility save)
   */
  getVisibility(studyID: string, optional?: string, forceRefresh: boolean = false): void {
    // Set studyId before applying visibility to ensure routes are built correctly
    this.studyId = studyID;
    sessionStorage.setItem('studyId', studyID);
    
    // Check if already loading to prevent duplicate API calls
    if (this.visibilityLoadingMap.get(studyID)) {
      return;
    }

    // Check cache first (unless force refresh is requested)
    if (!forceRefresh && this.isVisibilityCached(studyID)) {
      this.visibilityData = this.getCachedVisibility(studyID);
      if (this.visibilityData) {
        this.applyVisibilityToMenu();
      } else {
        this.applyDefaultMenu();
      }
      if (optional === 'navigate') {
        setTimeout(() => {
          this.navigateStudy(studyID);
        }, 100);
      }
      return;
    }

    // Mark as loading
    this.visibilityLoadingMap.set(studyID, true);
    this.visibilityData = null;

    this.visibilityService.getStudyVisiblity(studyID).subscribe((res) => {
      this.visibilityLoadingMap.set(studyID, false);
      
      if (res.status === 1) {
        if (res.data != null) {
          try {
            let data = res.data;
            while (typeof data === "string") {
              data = JSON.parse(data);
            }
            this.visibilityData = data;
          } catch (e) {
            this.visibilityData = null;
          }
          // Cache the visibility data
          this.visibilityCache.set(studyID, {
            data: this.visibilityData,
            timestamp: Date.now()
          });
          this.applyVisibilityToMenu();
        } else {
          // Cache null data to avoid repeated API calls
          this.visibilityCache.set(studyID, {
            data: null,
            timestamp: Date.now()
          });
          this.visibilityData = null;
          this.applyDefaultMenu();
        }
        
        if (optional === 'navigate') {
          setTimeout(() => {
            this.navigateStudy(studyID);
          }, 100);
        }
      } else {
        this.notifier.notify('error', 'something went wrong');
      }
    }, (error) => {
      this.visibilityLoadingMap.set(studyID, false);
      if (error.status === 403) {
        this.notifier.notify('error', 'User is not authorised');
      } else if (error.status === 401) {
        this.notifier.notify('error', 'User is not authorised');
      } else {
        this.notifier.notify('error', 'something went wrong');
      }
    });
  }

  getDashboardVisibility(studyID, optional?:string){
    this.visibilityData = null;
    // console.log("Fetching visibility for studyID: ",studyID,optional);
    this.visibilityService.getStudyVisiblity(studyID).subscribe((res)=>{
      if(res.status === 1){
        if(res.data != null){
          if(typeof(JSON.parse(res.data)) === "string"){
            this.visibilityData = JSON.parse(JSON.parse(res.data));
          }else{
            this.visibilityData = JSON.parse(res.data);
          }
          if(this.visibilityData && this.visibilityData['performaceTracker'] && this.visibilityData['performaceTracker']['show']){
            this.SetHomeMenusDetailsWithStudyId('performance_panel', true);
          }
          if(this.visibilityData && this.visibilityData['panelList'] && this.visibilityData['panelList']['show']){
            this.SetHomeMenusDetailsWithStudyId('panel_list', true);
          }
          if(this.visibilityData && this.visibilityData['biReport'] && this.visibilityData['biReport']['show']){
            this.SetHomeMenusDetailsWithStudyId('biReport', true);
          }
          if(this.visibilityData && this.visibilityData.survey && this.visibilityData.survey.show){
            this.SetHomeMenusDetailsWithStudyId('survey', true);
          }

          if(
            (this.visibilityData && this.visibilityData['funnelReport-beta'] && this.visibilityData['funnelReport-beta'].show) 
            || (this.visibilityData && this.visibilityData['utmReport-beta'] && this.visibilityData['utmReport-beta'].show) 
            || (this.visibilityData && this.visibilityData['termReport-beta'] && this.visibilityData['termReport-beta'].show)){
            this.SetHomeMenusDetailsWithStudyId('funnel_report', true);
          }
          

        }else{
          this.visibilityData = null;
          this.isFunnelReport = false;
          this.isTermReport = false;
          this.isUtmReport = false;
          this.SetHomeMenusDetailsWithStudyId('performance_panel', false);
          this.SetHomeMenusDetailsWithStudyId('panel_list', false);
          this.SetHomeMenusDetailsWithStudyId('biReport', false);
          Object.keys(this.access['access_rules']['study']).forEach((Skey)=>{
            this.SetHomeMenusDetailsWithStudyId(Skey, this.access['access_rules']['study'][Skey]);
          });
        }
        if(optional == 'navigate'){
          setTimeout(()=>{
            this.navigateStudy(studyID);
          },100);
        }
        if(this.visibilityData == null){
          this.isFunnelReport = false;
          this.isTermReport = false;
          this.isUtmReport = false;
          this.SetHomeMenusDetailsWithStudyId('performance_panel', false);
          this.SetHomeMenusDetailsWithStudyId('panel_list', false);
          this.SetHomeMenusDetailsWithStudyId('biReport', false);
          if (this.access['access_rules']['sub_side_drawer']) {
            Object.keys(this.access['access_rules']['sub_side_drawer']).forEach((Skey)=>{
              this.SetHomeMenusDetailsWithStudyId(Skey, this.access['access_rules']['sub_side_drawer'][Skey]);
            });
          }
        }
      }
      // else{
      //   this.notifier.notify('error','something went wrong');
      // }
    },(error)=>{
      // if (error.status === 403) {
      //   this.notifier.notify('error','User is not authorised');
      // }else if (error.status === 401) {
      //   this.notifier.notify('error','User is not authorised');
      // }else {
      //   this.notifier.notify('error','something went wrong');
      // }
    });
  }
}